import ServiceProviderDetailSidebarDefault from './container'
export { ServiceProviderDetailSidebarDefault }
export default ServiceProviderDetailSidebarDefault